import * as CookieConsent from "vanilla-cookieconsent";

// Initialize cookie consent
const initCookieConsent = () => {
	window.cookieConsent = CookieConsent;

	// Run the cookie consent banner
	CookieConsent.run({
		guiOptions: {
			consentModal: {
				layout: "bar",
				position: "bottom",
				equalWeightButtons: true,
				flipButtons: true,
			},
			preferencesModal: {
				layout: "box",
				position: "right",
				equalWeightButtons: true,
				flipButtons: false,
			},
		},

		categories: {
			necessary: {
				enabled: true,
				readOnly: true,
			},
			analytics: {
				enabled: false,
				readOnly: false,
			},
		},

		language: {
			default: "de",
			autoDetect: "document",
			translations: {
				de: {
					consentModal: {
						title: "Wir verwenden Cookies",
						description:
							"Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und Ihr Surferlebnis zu verbessern. Sie können für jede Kategorie wählen, ob Sie zustimmen oder ablehnen möchten.",
						acceptAllBtn: "Alle akzeptieren",
						acceptNecessaryBtn:
							"Nur essenzielle Cookies akzeptieren",
						showPreferencesBtn: "Einstellungen verwalten",
					},
					preferencesModal: {
						title: "Cookie-Einstellungen verwalten",
						acceptAllBtn: "Alle akzeptieren",
						acceptNecessaryBtn:
							"Nur essenzielle Cookies akzeptieren",
						savePreferencesBtn: "Auswahl speichern",
						closeIconLabel: "Schließen",
						sections: [
							{
								title: "Cookie-Verwendung",
								description:
									"Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und Ihr Surferlebnis zu verbessern. Sie können für jede Kategorie wählen, ob Sie zustimmen oder ablehnen möchten.",
							},
							{
								title: "Unbedingt erforderliche Cookies",
								description:
									"Diese Cookies sind für das ordnungsgemäße Funktionieren der Website unerlässlich. Sie ermöglichen die Nutzung sicherer Bereiche, Formulare und weitere grundlegende Funktionen. Ohne diese Cookies kann die Website nicht richtig funktionieren. Diese beinhalten den CRAFT_CSRF_TOKEN für Sicherheitsabfragen und CraftSessionId für Ihre Sitzung.",
								linkedCategory: "necessary",
							},
							{
								title: "Analyse-Cookies (Matomo)",
								description:
									"Diese Cookies und Skripte helfen uns zu verstehen, wie Besucher mit unserer Website interagieren. Wir nutzen Matomo, eine datenschutzfreundliche Analysesoftware, zur Verbesserung unserer Website. Alle Daten werden anonymisiert und können nicht dazu verwendet werden, Sie zu identifizieren.",
								linkedCategory: "analytics",
							},
							{
								title: "Weitere Informationen",
								description:
									'Weitere Informationen finden Sie in unserer <a href="/datenschutz">Datenschutzerklärung</a>.',
							},
						],
					},
				},
				en: {
					consentModal: {
						title: "We use cookies",
						description:
							"We use cookies to ensure the basic functionality of the website and to enhance your browsing experience. You can choose to opt in or out of each category.",
						acceptAllBtn: "Accept all",
						acceptNecessaryBtn: "Accept only essential cookies",
						showPreferencesBtn: "Manage preferences",
					},
					preferencesModal: {
						title: "Manage cookie preferences",
						acceptAllBtn: "Accept all",
						acceptNecessaryBtn: "Accept only essential cookies",
						savePreferencesBtn: "Save preferences",
						closeIconLabel: "Close",
						sections: [
							{
								title: "Cookie Usage",
								description:
									"We use cookies to ensure the basic functionality of the website and to enhance your browsing experience. You can choose to opt in or out of each category.",
							},
							{
								title: "Strictly Necessary Cookies",
								description:
									"These cookies are essential for the proper functioning of the website. They enable secure areas, forms, and other basic features. Without these cookies, the website cannot function properly. These include the CRAFT_CSRF_TOKEN for security queries and CraftSessionId for your session.",
								linkedCategory: "necessary",
							},
							{
								title: "Analytics Cookies (Matomo)",
								description:
									"These cookies and scripts help us understand how visitors interact with our website. We use Matomo, a privacy-friendly analytics software, to improve our website. All data is anonymized and cannot be used to identify you.",
								linkedCategory: "analytics",
							},
							{
								title: "More Information",
								description:
									'More information can be found in our <a href="/en/privacy-policy">privacy policy</a>.',
							},
						],
					},
				},
			},
		},
	});
};

export default {
	initCookieConsent,
};
